
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { BButton, BModal, BOverlay, BFormInput, BAlert } from 'bootstrap-vue';
import { Form } from '@/models/Form';
import { AxiosError, AxiosResponse } from 'axios';
import { mapGetters } from 'vuex';

@Component({
    name: 'ModalSendReport',
    components: {
        'b-alert': BAlert,
        'b-overlay': BOverlay,
        'b-modal': BModal,
        'b-button': BButton,
        'b-form-input': BFormInput,
    },
    computed: mapGetters(['form', 'accessCode']),
})
export default class ModalSendReport extends Vue {
    error = '';
    email = '';
    loading = false;

    onHide() {
        this.error = '';
        this.email = '';
    }

    async send() {
        this.loading = true;
        try {
            await this.$store.dispatch('send', { email: this.email });
            this.$bvModal.hide('modalSendReport');
        } catch (err) {
            this.error = err;
        } finally {
            this.loading = false;
        }
    }
}
